// src/pages/IndoorMap/locationsData.js
// NOTE: image values are placeholders — drop in your real Firebase
// Storage download URLs (…?alt=media&token=…) per room.
export const LOCATIONS = {
  "main-hall": {
    name: "Convention Hall",
    description: "Main Hall — the central gathering space and primary keynote venue for Converge 2026.",
    image: "https://firebasestorage.googleapis.com/v0/b/converge-2026.appspot.com/o/locations%2Fmain-hall.jpg?alt=media",
  },
  "food-radio": {
    name: "Courtyard",
    description: "Grab a bite, catch the live radio shift, and stop by the photo op corner.",
    image: "https://firebasestorage.googleapis.com/v0/b/converge-2026.appspot.com/o/locations%2Ffood-radio.jpg?alt=media",
  },
  "experience-zone": {
    name: "Scarlet Ballroom",
    description: "Experience Zone — interactive activations and hands-on experiences.",
    image: "https://firebasestorage.googleapis.com/v0/b/converge-2026.appspot.com/o/locations%2Fexperience-zone.jpg?alt=media",
  },
  "tulip-prefunction": {
    name: "Tulip Pre-Function",
    description: "A quieter pre-function space just off the main circulation path.",
    image: "https://firebasestorage.googleapis.com/v0/b/converge-2026.appspot.com/o/locations%2Ftulip-prefunction.jpg?alt=media",
  },
  valet: {
    name: "Convention Hall Entrance",
    description: "Valet / drop-off point and event registration.",
    image: "https://firebasestorage.googleapis.com/v0/b/converge-2026.appspot.com/o/locations%2Fvalet.jpg?alt=media",
  },
}